import { withInstall } from '@hd-front-end/utils'
import Link from './src/link.vue'

import type { SFCWithInstall } from '@hd-front-end/utils'

export const ElLink: SFCWithInstall<typeof Link> = withInstall(Link)
export default ElLink

export * from './src/link'
